import React, { useEffect, useState } from 'react'
import Frame from './Frame/Frame'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import themes from './Theme'
import { Brightness3, Brightness7 } from '@material-ui/icons'
import Dashboard from './Pages/Dashboard'
import Questions from './Pages/Questions'
import Notifications from './Pages/Notifications'
import LoginPage from './Pages/LoginPage'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'
import LastQuestions from "./Pages/LastQuestions";

const firebaseConfig = {
  apiKey: 'AIzaSyBXnJl-Cx88rqbWPkJn5GHRbJmLXCASTac',
  authDomain: 'winorfall.firebaseapp.com',
  databaseURL: 'https://winorfall.firebaseio.com',
  projectId: 'winorfall',
  storageBucket: 'winorfall.appspot.com',
  messagingSenderId: '1565246180',
  appId: '1:1565246180:web:da80b601a8075352b3a2f1',
  measurementId: 'G-4TV6P4XPWG',
}

firebase.initializeApp(firebaseConfig)

const App = () => {
  console.log("alpha1")
  const [theme, setTheme] = useState(false)
  const [user, setUser] = useState(firebase.auth().currentUser)
  useEffect(() => {
    setUser(localStorage.getItem('user'))
  }, [])
  const icon = !theme ? <Brightness7 /> : <Brightness3 />

  const appliedTheme = theme ? themes.lightTheme : themes.darkTheme
  if (user) {
    return (
      <ThemeProvider theme={createMuiTheme(appliedTheme)}>
        <Router>
          <Frame
            theme={theme}
            icon={icon}
            setTheme={setTheme}
            setUser={setUser}
          >
            <Switch>
              <Route exact path='/'>
                <Dashboard></Dashboard>
              </Route>
              <Route path='/questions'>
                <Questions></Questions>
              </Route>
              <Route path='/lastquestions'>
                <LastQuestions></LastQuestions>
              </Route>
              <Route path='/notifications'>
                <Notifications></Notifications>
              </Route>
            </Switch>
          </Frame>
        </Router>
      </ThemeProvider>
    )
  } else {
    return <LoginPage setUser={setUser}></LoginPage>
  }
}

export default App
